import { render, staticRenderFns } from "./PoiOpenClosed.vue?vue&type=template&id=c8d1108c"
import script from "./PoiOpenClosed.js?vue&type=script&lang=js&external"
export * from "./PoiOpenClosed.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports